/* istanbul ignore file */
import { parsers } from '@codegrade/utils';
/**
 * Describes what type of submission mode is enabled on the assignment
 */
export const AssignmentSubmissionMode = /* #__PURE__ */ parsers.exactly('full', 'simple');
